import { AnalyticsProvider } from '@faro/app-context';
import { useUser } from '@faro/auth';
import { UserInfo } from '@faro/user-management-model';
import { useSystemConfigQuery } from '../../query';

interface AppAnalyticsProviderProps {
    children: React.ReactNode;
}

export const AppAnalyticsProvider: React.FC<AppAnalyticsProviderProps> = ({ children }) => {
    const user = useUser<UserInfo>();
    const { data: systemConfig } = useSystemConfigQuery();
    const hostname = window?.location.hostname ?? '';
    const analyticsConfig = systemConfig?.analyticsConfig ?? { enabled: false, amplitudeapikey: '' };

    return (
        <AnalyticsProvider config={analyticsConfig} userInfo={user} tenant={hostname}>
            {children}
        </AnalyticsProvider>
    );
};
